/**
 * Imagen de respaldo cuando una escena o una terapia no tiene portada.
 *
 * El texto va PINTADO DENTRO del SVG, no en el DOM, asi que no lo alcanza
 * ningun extractor de cadenas: estaba en castellano en tres ficheros y un
 * usuario frances veia "Sin imagen" en medio de su portal.
 *
 * Se construye por llamada —no como constante de modulo— justamente para que
 * el texto pueda venir traducido. Es una cadena de texto, no una peticion de
 * red, asi que rehacerla en cada render no cuesta nada.
 */
export function imagenDeRespaldo(texto, { ancho = 150, alto = 90 } = {}) {
  const svg = `
    <svg xmlns='http://www.w3.org/2000/svg' width='${ancho}' height='${alto}'>
      <rect width='100%' height='100%' fill='#f3f4f6'/>
      <text x='50%' y='50%' font-size='12' fill='#9ca3af'
        text-anchor='middle' dominant-baseline='middle'>${texto}</text>
    </svg>`;
  return "data:image/svg+xml;utf8," + encodeURIComponent(svg);
}
